/**
 * @module core/storage/queries
 */

/**
 * Retorna um valor salvo no subsistema de armazenamento genérico
 * `storage` no caminho `keyPath` ou `notFound` alguma das chaves
 * de `keyPath` não exista.
 *
 * Função análoga ao método `Immutable.Map.getIn`.
 *
 * @param {Map} state estado do `Redux`.
 * @param {String} view `id` da `view` onde está armazenado o valor.
 * @param {Array} keyPath caminho de onde está armazenado o valor.
 * @param {any} notFound valor retornado caso `keyPath` não seja um
 * caminho existente.
 * @returns {any} o valor salvo no `storage` da `view` no `keyPath`.
 */
function get(state, view, keyPath, notFound) {
  const v = ['views', view, 'storage', ...keyPath];
  return state.getIn(v, notFound);
}

const queries = { get };

export default queries;
